import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import {
    FormControl,
    FormsModule,
    Validators,
    FormGroup,
} from "@angular/forms";
import { ActivatedRoute, Router, NavigationStart } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

import { InvoiceService } from "./../../../_services/invoice.service";
import { AuthService } from "src/app/_app-core/services/auth/auth.service";
import { Config } from "src/app/_store/config";

@Component({
    selector: "app-submit-logistics",
    templateUrl: "./submit-logistics.component.html",
    styleUrls: ["./submit-logistics.component.scss"],
})
export class SubmitLogisticsComponent implements OnInit {
    Config = Config;
    @ViewChild('sizeErrorModal') sizeErrorModal: TemplateRef<any>;
    selectedCompany: any;
    invoiceTypes = [
        { label: "IRN e-invoice", type: "e-invoice" },
        { label: "Digitally Signed e-invoice", type: "ds-invoice" },
    ];
    file: any;
    impersonate;

    docs = [
        {
            docType: "PO2S",
            description: "PO2S - Shipping Invoices",
        },
        {
            docType: "PO2X",
            description: "PO2X - Inbound Logistics",
        },
        {
            docType: "PO2O",
            description: "PO2O - Outbound Logistics",
        },
    ];

    loading = false;
    fileTypeError = false;
    qrCodeError = false;
    signatureError = false;
    validateSignature = false;
    validateEinvoice = false;
    validateEinvoiceResubmit = false;
    fileSizeError = false;
    responseData: any;
    displayName: any;
    message: any;
    poItems = [];
    files: any = [];
    poNo: any;
    fileUrl: any;
    safeUrl: any;
    pdfSrc: any;
    fileName: string = "";
    errorMessage: string = "";
    dsLoaderMsg = "";
    eLoaderMsg = "";
    isCondensed: boolean = false;
    currentLayout = {
        isCondensed: true,
    };
    eLoaderMsgResubmit = "";
    timeoutID;
    formSubmitted = false;
    unathourizedEmail = false;
    previousUrl: any;
    companies: any;
    organisations: any;
    configResCompanies: any;
    configResOrg: any;
    emailRes: any;

    logisticsData = new FormGroup({
        invoiceType: new FormControl(null, [Validators.required]),
        file: new FormControl(null),
        fileSource: new FormControl("", [Validators.required]),
        email: new FormControl("", [
            Validators.required,
            Validators.email,
            Validators.pattern(
                "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$"
            ),
        ]),
        poNo: new FormControl("", [
            Validators.pattern("^[0-9]*$"),
            Validators.minLength(10),
            Validators.maxLength(10),
        ]),
        companyCode: new FormControl("", [Validators.required]),
        purchaseOrg: new FormControl("", [Validators.required]),
        docType: new FormControl("", [Validators.required]),
    });

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private http: HttpClient,
        private invoiceService: InvoiceService,
        private authService: AuthService,
        private modalService: NgbModal
    ) {}

    selectInvoice(event: any) {
        this.qrCodeError = false;

        this.invoiceService.setFileElement(event[0]);
        localStorage.setItem("invoiceFile", event[0]);

        if (event.length > 0) {
            const fileUploaded = event[0];

            if (fileUploaded.type !== "application/pdf") {
                this.fileTypeError = true;
            } else if (fileUploaded.size > Config.maxFileSize) {
                this.fileSizeError = true;
                this.modalService.open(this.sizeErrorModal, { centered: true, size: 'sm' });
            } else {
                this.logisticsData.patchValue({
                    fileSource: fileUploaded,
                });
                this.fileTypeError = false;
                this.fileSizeError = false;
            }
        }

        this.fileName = event[0].name;
    }

    extrationMessages(msg, time) {
        this.timeoutID = setTimeout(() => {
            this.eLoaderMsg = msg;
        }, time);
    }

    extrationResubmitMessages(msg, time) {
        this.timeoutID = setTimeout(() => {
            this.eLoaderMsgResubmit = msg;
        }, time);
    }

    onInvoiceSubmit() {
        if (this.fileSizeError || this.fileTypeError) {
            return;
        }
        this.loading = true;
        this.qrCodeError = false;

        if (this.logisticsData.value.invoiceType === "e-invoice") {
            this.validateEinvoice = true;
            this.validateSignature = false;

            this.invoiceService.setInvoiceType("logistics");
            this.invoiceService.setInvType("e-invoice");

            const ledger: any[] = [
                {
                    docType: this.logisticsData.value.docType,
                    docDetail: {
                        docFormat: "e-invoice",
                        docCat: "logistics",
                    },
                    cmpCode: this.logisticsData.value.companyCode,
                    purchaseOrg: this.logisticsData.value.purchaseOrg,
                    erpDocType: this.logisticsData.value.docType,
                },
            ];

            const formData: any = new FormData();
            formData.append("sellerCode", localStorage.getItem("sellerCode"));
            formData.append("supplierCode", localStorage.getItem("vendorCode"));
            formData.append("ledger", JSON.stringify(ledger));
            formData.append("invoiceFile", this.logisticsData.value.fileSource);
            formData.append("extractionVersion", "1");

            this.eLoaderMsg = "Verifying QR Code";
            this.extrationMessages("Authenticating QR Code", 5000);
            this.extrationMessages("Extracting Data", 10000);
            this.extrationMessages("Validating Data", 15000);

            this.invoiceService.extractInvoice(formData).subscribe(
                (res) => {
                    this.loading = false;
                    this.validateEinvoice = false;
                    this.validateSignature = false;
                    this.qrCodeError = false;
                    this.responseData = res;
                    console.log("this is extract invoice response");

                    console.log(res);
                    if (
                        this.responseData.length !== 0 &&
                        this.responseData.status === "error"
                    ) {
                        console.log("error");
                        if (this.responseData.msg.includes("unreadable")) {
                            this.loading = true;
                            this.validateEinvoiceResubmit = true;

                            this.eLoaderMsgResubmit =
                                "Sorry, QR code in your uploaded file is not legible. We will optimize your file now and retry.";

                            formData.set("extractionVersion", "2");

                            this.extrationResubmitMessages(
                                "Verifying QR Code",
                                5000
                            );
                            this.extrationResubmitMessages(
                                "Authenticating QR Code",
                                10000
                            );
                            this.extrationResubmitMessages(
                                "Extracting Data",
                                15000
                            );
                            this.extrationResubmitMessages(
                                "Validating Data",
                                20000
                            );

                            setTimeout(() => {
                                this.invoiceService
                                    .extractInvoice(formData)
                                    .subscribe(
                                        (res) => {
                                            this.responseData = res;

                                            if (
                                                this.responseData.length !==
                                                    0 &&
                                                this.responseData.status ===
                                                    "error"
                                            ) {
                                                this.validateEinvoiceResubmit =
                                                    false;
                                                this.qrCodeError = true;
                                                this.message =
                                                    this.responseData.msg;
                                            } else {
                                                this.qrCodeError = false;
                                                this.invoiceService.setProcessedInvoice(
                                                    this.responseData
                                                );
                                                const processedInvoice = {
                                                    file_link:
                                                        this.responseData.data
                                                            .meta.src,
                                                    supporting_docs:
                                                        this.responseData.data
                                                            .meta
                                                            .supportingDocsSrc ||
                                                        [],
                                                    invoice_number:
                                                        this.responseData.data
                                                            .rec.docId,
                                                    invoice_date:
                                                        this.responseData.data
                                                            .meta.docDate,
                                                    invoice_amount:
                                                        this.responseData.data
                                                            .rec.docDetail
                                                            .docAmt,
                                                    irn: this.responseData.data
                                                        .rec.docDetail.docIrn,
                                                    gstin:
                                                        this.responseData.data
                                                            .rec.docDetail
                                                            .docGstin,
                                                    cmpCode:
                                                        this.logisticsData
                                                            .value.companyCode,
                                                    purchaseOrg:
                                                        this.logisticsData
                                                            .value.purchaseOrg,
                                                    erpDocType:
                                                        this.logisticsData
                                                            .value.docType,
                                                    email_address:
                                                        this.logisticsData
                                                            .value.email,
                                                    poNo: this.logisticsData
                                                        .value.poNo,
                                                    username:
                                                        this.invoiceService.getUsername(),
                                                    user_id:
                                                        this.invoiceService.getUserId(),
                                                    barcodePrefix:
                                                        this.responseData.data
                                                            .rec.barcodePrefix,
                                                };
                                                console.log(
                                                    processedInvoice,
                                                    "processedInvoice"
                                                );

                                                localStorage.setItem(
                                                    "invoiceDetails",
                                                    JSON.stringify(
                                                        processedInvoice
                                                    )
                                                );
                                                this.router.navigateByUrl(
                                                    "/invoice-preview-logistics"
                                                );
                                            }
                                        },
                                        (error) => {
                                            console.log(error);
                                        }
                                    );
                            }, 22000);
                        }
                    } else {
                        console.log("Success here");
                        this.qrCodeError = false;
                        const processedInvoice = {
                            file_link: this.responseData.data.meta.src,
                            supporting_docs:
                                this.responseData.data.meta.supportingDocsSrc ||
                                [],
                            invoice_number: this.responseData.data.rec.docId,
                            invoice_date: this.responseData.data.meta.docDate,
                            invoice_amount:
                                this.responseData.data.rec.docDetail.docAmt,
                            irn: this.responseData.data.rec.docDetail.docIrn,
                            gstin: this.responseData.data.rec.docDetail.docGstin,
                            cmpCode: this.logisticsData.value.companyCode,
                            purchaseOrg: this.logisticsData.value.purchaseOrg,
                            erpDocType: this.logisticsData.value.docType,
                            email_address: this.logisticsData.value.email,
                            poNo: this.logisticsData.value.poNo,
                            username: this.invoiceService.getUsername(),
                            user_id: this.invoiceService.getUserId(),
                            barcodePrefix:
                                this.responseData.data.rec.barcodePrefix,
                        };
                        this.invoiceService.setProcessedInvoice(
                            processedInvoice
                        );

                        localStorage.setItem(
                            "invoiceDetails",
                            JSON.stringify(processedInvoice)
                        );
                        this.router.navigateByUrl(
                            "/invoice-preview-logistics"
                        );
                    }
                },
                (error) => {
                    this.loading = false;
                    this.qrCodeError = true;
                    this.validateEinvoice = false;
                    this.validateSignature = false;
                    this.errorMessage = error;
                    console.log(error);
                }
            );
        } else {
            this.validateSignature = true;
            this.validateEinvoice = false;

            this.invoiceService.setInvoiceType("logistics");
            this.invoiceService.setInvType("ds-invoice");
            this.invoiceService.setPo(this.logisticsData.value.poNo);

            const ledger: any[] = [
                {
                    docType: this.logisticsData.value.docType,
                    docDetail: {
                        docFormat: "ds-invoice",
                        docCat: "logistics",
                    },
                    cmpCode: this.logisticsData.value.companyCode,
                    purchaseOrg: this.logisticsData.value.purchaseOrg,
                    erpDocType: this.logisticsData.value.docType,
                },
            ];

            const formData: any = new FormData();
            formData.append("sellerCode", localStorage.getItem("sellerCode"));
            formData.append("supplierCode", localStorage.getItem("vendorCode"));
            formData.append("ledger", JSON.stringify(ledger));
            formData.append("invoiceFile", this.logisticsData.value.fileSource);

            this.dsLoaderMsg = "Verifying Signature";

            setTimeout(() => {
                this.dsLoaderMsg = "Authenticating Signature";
            }, 2000);
            setTimeout(() => {
                this.dsLoaderMsg = "Extracting Data";
            }, 4000);
            setTimeout(() => {
                this.dsLoaderMsg = "Validating Data";
            }, 6000);

            this.invoiceService.verifyDigitalSignature(formData).subscribe(
                (res) => {
                    this.loading = false;
                    this.validateEinvoice = false;
                    this.validateSignature = false;
                    this.responseData = res;

                    if (
                        this.responseData.length !== 0 &&
                        this.responseData.status === "error"
                    ) {
                        this.loading = true;
                        this.signatureError = true;
                        this.message = this.responseData.msg;
                    } else {
                        this.qrCodeError = false;
                        this.poNo = this.route.snapshot.params["poNo"];
                        this.invoiceService.setFileUrl(
                            this.responseData.file_link
                        );
                        const processedInvoice = {
                            file_link: this.responseData.data.meta.src,
                            supporting_docs:
                                this.responseData.data.meta.supportingDocsSrc ||
                                [],
                            invoice_number: this.responseData.data.rec.docId,
                            invoice_date: this.responseData.data.meta.docDate,
                            invoice_amount:
                                this.responseData.data.rec.docDetail.docAmt,
                            irn: this.responseData.data.rec.docDetail.docIrn,
                            gstin: this.responseData.data.rec.docDetail.docGstin,
                            cmpCode: this.logisticsData.value.companyCode,
                            purchaseOrg: this.logisticsData.value.purchaseOrg,
                            erpDocType: this.logisticsData.value.docType,
                            email_address: this.logisticsData.value.email,
                            poNo: this.logisticsData.value.poNo,
                            username: this.invoiceService.getUsername(),
                            user_id: this.invoiceService.getUserId(),
                            barcodePrefix:
                                this.responseData.data.rec.barcodePrefix,
                            src: this.responseData.data.meta.src,
                        };
                        this.invoiceService.setDataDigitalInvoice(
                            processedInvoice
                        );
                        localStorage.setItem(
                            "invoiceDetails",
                            JSON.stringify(processedInvoice)
                        );
                        this.router.navigate([
                            "/digital-invoice-preview-logistics",
                        ]);
                    }
                },
                (error) => {
                    this.loading = false;
                    this.qrCodeError = true;
                    this.validateEinvoice = false;
                    this.validateSignature = false;
                    this.errorMessage = error;
                    console.log(error);
                }
            );
        }
    }

    fetchPurchaseOrg() {
        const configReq = {
            type: "purchaseOrganizations",
        };

        this.invoiceService.getConfig(configReq).subscribe(
            (res) => {
                this.configResOrg = res;
                if (
                    this.configResOrg.length !== 0 &&
                    this.configResOrg.status === "error"
                ) {
                    console.log(this.configResOrg + " Error");
                } else {
                    this.organisations = this.configResOrg.data;
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }

    fetchCompanyCode() {
        const configReq = {
            type: "companyCodes",
        };

        this.invoiceService.getConfig(configReq).subscribe(
            (res) => {
                this.configResCompanies = res;
                if (
                    this.configResCompanies.length !== 0 &&
                    this.configResCompanies.status === "error"
                ) {
                    console.log(this.configResCompanies + " Error");
                } else {
                    this.companies = this.configResCompanies.data;
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }

    ngOnInit(): void {
        this.displayName = localStorage.getItem("displayName");
        this.formSubmitted = false;
        if (
            localStorage.getItem("impersonation") === null ||
            localStorage.getItem("impersonation") === ""
        ) {
            this.impersonate = "false";
        } else {
            this.impersonate = localStorage.getItem("impersonation");
        }

        this.fetchCompanyCode();
        this.fetchPurchaseOrg();
    }

    closeFileErrorDialog() {
        this.loading = false;
        this.fileTypeError = false;
        this.qrCodeError = false;
    }

    closeSignatureErrorDialog() {
        this.loading = false;
        this.signatureError = false;
        this.qrCodeError = false;
    }

    resubmitInvoice() {
        this.router.navigateByUrl("/submit-logistics");
    }
}
